import React from 'react';
import { LinkedinIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { SectionPager } from '../components/SectionPager';
import { Reveal } from '../components/Reveal';
import { PortraitFrame } from '../components/PortraitFrame';
import { profile } from '../data/profile';
const engagementTypes = ['Board appointments and advisory seats', 'Executive advisory for PE-backed portfolio companies', 'C-suite product leadership (CPO / SVP Product)', 'Pre-transaction diligence and exit readiness'];
export function Contact() {
  return <>
      <PageHeader number="10" title="Contact & Availability" blurb="Board appointments, executive advisory, and C-suite leadership roles." data-id="element-167" data-mp="17qqrwn676mlv" />

      <section className="bg-paper py-20 lg:py-24" data-id="element-168" data-mp="f9xzx9cmm5zy">
        <div className="mx-auto grid max-w-shell gap-12 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-169" data-mp="f8my3f2qr8bh">
          <div className="lg:col-span-4" data-id="element-170" data-mp="aalconhuewwu">
            <Reveal data-id="element-171" data-mp="15ff6q4dxknac">
              <div className="max-w-[17rem]" data-id="element-172" data-mp="15g8dv6gsxet0">
                <PortraitFrame data-id="element-173" data-mp="15f6so962nbxk" />
              </div>
              <p className="mt-6 font-display text-2xl font-light text-navy" data-id="element-174" data-mp="19g8sar3whq02">{profile.name}</p>
              <p className="mt-1.5 text-[11px] uppercase tracking-overline text-gold" data-id="element-175" data-mp="1e78qs0so4g4o">
                SVP, Product Management · Board Advisor
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-8" data-id="element-176" data-mp="mh2qxzsikf5s">
            <Reveal delay={0.06} data-id="element-177" data-mp="midwo55irwzj">
              <h2 className="font-display text-3xl font-light leading-[1.2] text-navy lg:text-[2.4rem]" data-id="element-178" data-mp="qi6b2yhlgxct">
                Open to board appointments, executive advisory, and C-suite leadership roles.
              </h2>

              <dl className="mt-10 divide-y divide-navy/10 border-y border-navy/15" data-id="element-179" data-mp="10gvifxbv6zet">
                <div className="flex items-start gap-4 py-5" data-id="element-180" data-mp="26wo9zduhlfbo">
                  <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-181" data-mp="26w67w0l586vu" />
                  <div data-id="element-182" data-mp="2bto6ax1jb3pl">
                    <dt className="text-[11px] uppercase tracking-overline text-steel" data-id="element-183" data-mp="2bxbxhpjibe15">Email</dt>
                    <dd className="mt-1" data-id="element-184" data-mp="1m96lv34hohsn">
                      <a href={`mailto:${profile.email}`} className="text-[15px] text-navy underline decoration-navy/25 underline-offset-4 transition-colors duration-150 ease-out hover:decoration-gold" data-id="element-185" data-mp="1h78u1ki0weo3">
                        {profile.email}
                      </a>
                    </dd>
                  </div>
                </div>

                <div className="flex items-start gap-4 py-5" data-id="element-186" data-mp="yj3uyqcb9hvm">
                  <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-187" data-mp="1d6f7ovk8b7xb" />
                  <div data-id="element-188" data-mp="18g8kn05d7vh6">
                    <dt className="text-[11px] uppercase tracking-overline text-steel" data-id="element-189" data-mp="18fp3vmrgbd4q">Location</dt>
                    <dd className="mt-1 text-[15px] text-navy/85" data-id="element-190" data-mp="kpck9emufryb">{profile.location}</dd>
                  </div>
                </div>

                <div className="flex items-start gap-4 py-5" data-id="element-191" data-mp="fr1bl78abnho">
                  <LinkedinIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-192" data-mp="2red9ghkcdznu" />
                  <div data-id="element-193" data-mp="2w5mxxeu5mwy5">
                    <dt className="text-[11px] uppercase tracking-overline text-steel" data-id="element-194" data-mp="2w6xvuy0x5ahc">LinkedIn</dt>
                    <dd className="mt-1" data-id="element-195" data-mp="2hi1t9ghmspo4">
                      <a href={profile.linkedin} target="_blank" rel="noreferrer" className="text-[15px] text-navy underline decoration-navy/25 underline-offset-4 transition-colors duration-150 ease-out hover:decoration-gold" data-id="element-196" data-mp="2mfaclkeimzqy">
                        {profile.linkedinLabel}
                      </a>
                    </dd>
                  </div>
                </div>
              </dl>

              <div className="mt-10" data-id="element-197" data-mp="1ppj9iws5s49j">
                <p className="text-[11px] uppercase tracking-overline text-steel" data-id="element-198" data-mp="1pohrg8cq6hib">
                  Engagement types
                </p>
                <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-199" data-mp="1tojog47immr9">
                  {engagementTypes.map(t => <li key={t} className="flex gap-3" data-id="element-200" data-mp="257kiynikru3u">
                      <span aria-hidden="true" className="mt-[11px] h-px w-4 shrink-0 bg-gold" data-id="element-201" data-mp="255zn8ukiy54e" />
                      <span className="text-[14px] leading-[1.7] text-navy/85" data-id="element-202" data-mp="208r68xb4474q">{t}</span>
                    </li>)}
                </ul>
              </div>

              <div className="mt-10 flex flex-col gap-3 sm:flex-row" data-id="element-203" data-mp="2svty56la9jm0">
                <a href={`mailto:${profile.email}?subject=Executive%20Consultation`} className="inline-flex items-center justify-center bg-gold-bright px-7 py-4 text-[13px] font-medium uppercase tracking-overline text-navy transition-colors duration-150 ease-out hover:bg-gold-soft" data-id="element-204" data-mp="2ny1x9n2nun5o">
                  Schedule Executive Consultation
                </a>
                <a href={`mailto:${profile.email}?subject=Executive%20Bio%20Request`} className="inline-flex items-center justify-center border border-navy/25 px-7 py-4 text-[13px] font-medium uppercase tracking-overline text-navy transition-colors duration-150 ease-out hover:border-navy hover:bg-white" data-id="element-205" data-mp="13hfg154rsuzh">
                  Request Executive Bio
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <SectionPager current="/contact" data-id="element-206" data-mp="1qxe69ozf1po" />
    </>;
}